import styled from "styled-components";

const StyledField = styled.label<{ mb?: string }>`
  display: block;
  background: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  border: 1px solid ${(props) => props.theme.colors.gray};
  padding: 2rem;
  margin-bottom: ${({ mb }) => mb ?? "2rem"};
`;

export default StyledField;
